import { NgModule } from '@angular/core';

import { SbbIconDirective } from './icon.directive';

@NgModule({
  declarations: [SbbIconDirective],
  exports: [SbbIconDirective],
})
export class SbbIconDirectiveModule {}
